import $ from "jquery";
import "../../styles/global.less";
import "../../styles/reset.less";
import "./data-solution.less";

import Swiper from "swiper";
import "../../styles/swiper-bundle.min.css";
var swiper;

let fsTableList;
let menuItemBoxs;
let titleListBoxs;
let anliboxDoms;
let solutionBlocklist;
let caseListDoms;
let cjListDoms; // swiper 轮播图上点击按钮列表
var scrollTop = 0;

$(document).ready(function () {
  setRemFontSize();

  window.addEventListener("resize", function () {
    setRemFontSize();
  });
  $(window).scroll(function () {
    scrollTop = $(document).scrollTop();

    var difference = scrollTop - 200;
    var topOpacity = 0;

    if (difference > 70) {
      topOpacity = 0;
    }

    if (difference > 0 && difference < 70) {
      topOpacity = difference / 70;
    }

    if (difference >= 70) {
      topOpacity = 1;
    }

    $("#topHeader").css(
      "background-color",
      "rgba(1, 84, 155," + topOpacity + ")"
    );
  });

  let currentFsIndex = 0;
  fsTableList = $(".fs-table");
  menuItemBoxs = $(".menu-item-box");
  titleListBoxs = $(".wrapper-title-left");
  anliboxDoms = $(".anli-box");
  caseListDoms = $(".case-list li");
  solutionBlocklist = $(".solution-block");

  fsTableList.each((index, item) => {
    $(item).hide();
  });

  titleListBoxs.each((index, item) => {
    $(item).hide();
  });

  anliboxDoms.each((index, item) => {
    $(item).hide();
  });

  solutionBlocklist.each((index, item) => {
    if (index !== 0) {
      $(item).hide();
    }
  });

  caseListDoms.each((index, item) => {
    $(item).click(() => {
      solutionBlocklist.each((sindex, sitem) => {
        if (index === sindex) {
          $(sitem).show();
        } else {
          $(sitem).hide();
        }
      });
    });
  });

  showFsTable(currentFsIndex);

  menuItemBoxs.each((index, item) => {
    $(item).click(() => {
      showFsTable(index);
    });
  });

  cjListDoms = $(".cj-list>li");

  cjListDoms.each((index, item) => {
    $(item).bind("click", () => {
      swiper.slideTo(index);
    });
  });

  swiper = new Swiper(".mySwiper", {
    direction: "horizontal",
    autoplay: {
      delay: 6000,
    },
    // loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      slideChange: function () {
        cjListDoms.each((index, item) => {
          $(item).removeClass("active");
          if (index === this.activeIndex) {
            $(item).addClass("active");
          }
        });
      },
    },
  });

  $(".swiper-button-next").click(() => {
    swiper.slideNext();
  });

  $(".swiper-button-prev").click(() => {
    swiper.slidePrev();
  });
});

window.showFsTable = (index) => {
  fsTableList.each((i, item) => {
    if (i === index) {
      $(item).show();
    } else {
      $(item).hide();
    }
  });

  titleListBoxs.each((i, item) => {
    if (i === index) {
      $(item).show();
    } else {
      $(item).hide();
    }
  });

  menuItemBoxs.each((i, item) => {
    $(item).parent().removeClass("active");
    if (i === index) {
      $(item).parent().addClass("active");
    }
  });

  anliboxDoms.each((i, item) => {
    if (i === index) {
      $(item).show();
    } else {
      $(item).hide();
    }
  });
};

window.setRemFontSize = function setRemFontSize() {
  var wsize = window.innerWidth;
  var size = wsize > 1240 ? wsize / 10 : 1240 / 10;
  document.documentElement.style.fontSize = size + "px";
};
